<script>
  import { getContext } from 'svelte';
  import SectionNav from '../../../../components/navigation/section';
  import {
    addNotification,
    ICONS
  } from '../../../../utils/notifications.store';

  import EventGeneral from './event.general';
  import EventCommunications from './event.communications';
  import EventStatus from './event.status';
  import moment from 'moment';
  import { ADD_EVENT } from '../../../../graphql/events';

  export let value;

  const client = getContext('apollo');
  const history = getContext('history');

  async function save() {
    const input = {
      name: value.program.name,
      category: value.program.category.id,
      secondaryCategory: value.program.secondaryCategory.id,
      program: value.program.id,
      date: value.date,
      startTime: moment(value.startTime).format('h:mm A'),
      endTime: moment(value.endTime).format('h:mm A'),
      staffStartTime:  moment(value.staffStartTime).format('h:mm A'),
      staffEndTime:  moment(value.staffEndTime).format('h:mm A'),
      constraintCapacityTotal: parseInt(value.constraintCapacityTotal || 0),
      constraintStaff: parseInt(value.constraintStaff || 0),
      constraintAllowEarlyRegistration:
        value.constraintAllowEarlyRegistration || false,
      constraintAllowGroupRegistration:
        value.constraintAllowGroupRegistration || false,
      constraintCapacityGroup: parseInt(value.constraintCapacityGroup || 0),
      leader: value.leader.id,
      notes: value.notes,
      published: value.published,
      registrationOpenDate: value.registrationOpenDate,
      earlyRegistrationOpenDate: value.earlyRegistrationOpenDate,
      constraintPrivate: value.constraintPrivate || false,
      published: value.published,
      constraintCapacityPublic:
        parseInt(value.constraintCapacityTotal) -
        parseInt(value.constraintCapacityGroup || 0),
      communications: value.communications.map(communication => {
        return {
          parent: communication.parent,
          useParent: communication.useParent || false,
          type: communication.type,
          body: communication.body,
          subject: communication.subject
        };
      })
    };

    if (value.id) {
      input.id = value.id;
    }

    const variables = {
      input
    };

    try {
      addNotification({ icon: ICONS.LOADING, message: `Saving ${value.name}` });

      const { data } = await client.mutate({ mutation: ADD_EVENT, variables });

      if (data.addEvent.id) {
        history.push(`/events/view/${data.addEvent.id}`);
      }

      addNotification({
        time: 3000,
        message: `Successfully Saved ${input.name}`,
        icon: ICONS.SUCCESS
      });
    } catch (e) {
      addNotification({
        message: `Error Saving ${input.name}`,
        icon: ICONS.ERROR
      });
    }
  }
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <EventGeneral review="{true}" value="{value}"></EventGeneral>
    <EventStatus review="{true}" value="{value}"></EventStatus>
    <EventCommunications review="{true}" value="{value}"></EventCommunications>
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav hasSub="{true}">
      <div on:click="{save}" class="save">
        ADD EVENT
      </div>
    </SectionNav>
  </div>
</div>
